import { CmsAxios, throwErrorResponse } from 'src/common/services/axios';
import { flatten } from 'src/lib/axios';
import { StaticPageCode, StaticPageDTO } from 'src/common/models/staticPage';
import { AboutUsStaticPageDTO } from 'src/common/models/aboutUsStaticPage';
import { stringify } from 'qs';

const FILE_FIELDS = ['id', 'height', 'url', 'width'];

export const getAboutUsStaticPage = () =>
  CmsAxios.get<AboutUsStaticPageDTO>(
    `/about-us?${stringify(
      {
        populate: {
          additional: {
            fields: ['heading', 'id', 'subtitle', 'text'],
            populate: {
              image: {
                fields: FILE_FIELDS,
              },
            },
          },
          benefits: {
            fields: ['heading', 'id', 'subtitle'],
            populate: {
              list: {
                fields: ['id', 'text'],
                populate: {
                  icon: {
                    fields: FILE_FIELDS,
                  },
                },
              },
            },
          },
          knowledge: {
            fields: ['heading', 'id', 'subtitle', 'text'],
            populate: {
              image: {
                fields: FILE_FIELDS,
              },
              list: {
                fields: ['id', 'text'],
              },
            },
          },
          possibilities: {
            fields: ['heading', 'id', 'subtitle', 'text'],
            populate: {
              list: {
                fields: ['id', 'text'],
              },
            },
          },
          strengths: {
            fields: ['heading', 'id', 'subtitle'],
            populate: {
              list: {
                fields: ['id', 'text', 'unit', 'value'],
              },
            },
          },
          whatIsPfp: {
            fields: ['heading', 'id', 'text'],
            populate: {
              image: {
                fields: FILE_FIELDS,
              },
            },
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    )}`,
  )
    .then(flatten)
    .catch(throwErrorResponse);

export const getStaticPage = (code: StaticPageCode) =>
  CmsAxios.get<StaticPageDTO>(
    `/${code}?${stringify(
      {
        populate: {
          attachment: {
            populate: {
              file: {
                fields: FILE_FIELDS,
              },
            },
          },
          content: '*',
        },
      },
      {
        encodeValuesOnly: true,
      },
    )}`,
  )
    .then(flatten)
    .catch(throwErrorResponse);
